/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateRebalancingScheduleData } from '../models';
// @ts-ignore
import type { ListRebalancingSchedulesResponse } from '../models';
// @ts-ignore
import type { RebalancingSchedule } from '../models';
// @ts-ignore
import type { Status } from '../models';
// @ts-ignore
import type { UpdateRebalancingScheduleData } from '../models';
/**
 * ScheduledRebalancingAPIApi - axios parameter creator
 * @export
 */
export const ScheduledRebalancingAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new rebalancing schedule  for a cluster.    (-- api-linter: core::0133::http-body=disabled      aip.dev/not-precedent: Using a custom data field for better SDK generation. --)
         * @summary Creates a rebalancing schedule for the cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {CreateRebalancingScheduleData} createRebalancingScheduleData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPICreateRebalancingSchedule: async (organizationId: string, clusterId: string, createRebalancingScheduleData: CreateRebalancingScheduleData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('scheduledRebalancingAPICreateRebalancingSchedule', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('scheduledRebalancingAPICreateRebalancingSchedule', 'clusterId', clusterId)
            // verify required parameter 'createRebalancingScheduleData' is not null or undefined
            assertParamExists('scheduledRebalancingAPICreateRebalancingSchedule', 'createRebalancingScheduleData', createRebalancingScheduleData)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-schedules`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRebalancingScheduleData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a rebalancing schedule.
         * @summary Deletes a rebalancing schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing schedule to delete.  This is the RebalancePlanSchedule CRD name (metadata.name).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPIDeleteRebalancingSchedule: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('scheduledRebalancingAPIDeleteRebalancingSchedule', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('scheduledRebalancingAPIDeleteRebalancingSchedule', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduledRebalancingAPIDeleteRebalancingSchedule', 'id', id)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-schedules/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a rebalancing schedule by ID.
         * @summary Gets a rebalancing schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing schedule to retrieve.  This is the RebalancePlanSchedule CRD name (metadata.name).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPIGetRebalancingSchedule: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('scheduledRebalancingAPIGetRebalancingSchedule', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('scheduledRebalancingAPIGetRebalancingSchedule', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduledRebalancingAPIGetRebalancingSchedule', 'id', id)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-schedules/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists rebalancing schedules for a cluster.
         * @summary Lists rebalancing schedules for a cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [enabledFilter] Filter by enabled status (optional).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPIListRebalancingSchedules: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, enabledFilter?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('scheduledRebalancingAPIListRebalancingSchedules', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('scheduledRebalancingAPIListRebalancingSchedules', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-schedules`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (enabledFilter !== undefined) {
                localVarQueryParameter['enabledFilter'] = enabledFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enables or disables a rebalancing schedule.
         * @summary Enables or disables a rebalancing schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing schedule to toggle.  This is the RebalancePlanSchedule CRD name (metadata.name).
         * @param {boolean} [enabled] Whether to enable or disable the schedule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPIToggleRebalancingSchedule: async (organizationId: string, clusterId: string, id: string, enabled?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('scheduledRebalancingAPIToggleRebalancingSchedule', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('scheduledRebalancingAPIToggleRebalancingSchedule', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduledRebalancingAPIToggleRebalancingSchedule', 'id', id)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-schedules/{id}:toggle`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a rebalancing schedule.    (-- api-linter: core::0134::http-body=disabled      aip.dev/not-precedent: Using a custom data field for better SDK generation. --)
         * @summary Updates a rebalancing schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing schedule to update.  This is the RebalancePlanSchedule CRD name (metadata.name).
         * @param {UpdateRebalancingScheduleData} updateRebalancingScheduleData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPIUpdateRebalancingSchedule: async (organizationId: string, clusterId: string, id: string, updateRebalancingScheduleData: UpdateRebalancingScheduleData, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('scheduledRebalancingAPIUpdateRebalancingSchedule', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('scheduledRebalancingAPIUpdateRebalancingSchedule', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduledRebalancingAPIUpdateRebalancingSchedule', 'id', id)
            // verify required parameter 'updateRebalancingScheduleData' is not null or undefined
            assertParamExists('scheduledRebalancingAPIUpdateRebalancingSchedule', 'updateRebalancingScheduleData', updateRebalancingScheduleData)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-schedules/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRebalancingScheduleData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScheduledRebalancingAPIApi - functional programming interface
 * @export
 */
export const ScheduledRebalancingAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScheduledRebalancingAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new rebalancing schedule  for a cluster.    (-- api-linter: core::0133::http-body=disabled      aip.dev/not-precedent: Using a custom data field for better SDK generation. --)
         * @summary Creates a rebalancing schedule for the cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {CreateRebalancingScheduleData} createRebalancingScheduleData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduledRebalancingAPICreateRebalancingSchedule(organizationId: string, clusterId: string, createRebalancingScheduleData: CreateRebalancingScheduleData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RebalancingSchedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduledRebalancingAPICreateRebalancingSchedule(organizationId, clusterId, createRebalancingScheduleData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledRebalancingAPIApi.scheduledRebalancingAPICreateRebalancingSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a rebalancing schedule.
         * @summary Deletes a rebalancing schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing schedule to delete.  This is the RebalancePlanSchedule CRD name (metadata.name).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduledRebalancingAPIDeleteRebalancingSchedule(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RebalancingSchedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduledRebalancingAPIDeleteRebalancingSchedule(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledRebalancingAPIApi.scheduledRebalancingAPIDeleteRebalancingSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a rebalancing schedule by ID.
         * @summary Gets a rebalancing schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing schedule to retrieve.  This is the RebalancePlanSchedule CRD name (metadata.name).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduledRebalancingAPIGetRebalancingSchedule(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RebalancingSchedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduledRebalancingAPIGetRebalancingSchedule(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledRebalancingAPIApi.scheduledRebalancingAPIGetRebalancingSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists rebalancing schedules for a cluster.
         * @summary Lists rebalancing schedules for a cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [enabledFilter] Filter by enabled status (optional).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduledRebalancingAPIListRebalancingSchedules(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, enabledFilter?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRebalancingSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduledRebalancingAPIListRebalancingSchedules(organizationId, clusterId, pageLimit, pageCursor, enabledFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledRebalancingAPIApi.scheduledRebalancingAPIListRebalancingSchedules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enables or disables a rebalancing schedule.
         * @summary Enables or disables a rebalancing schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing schedule to toggle.  This is the RebalancePlanSchedule CRD name (metadata.name).
         * @param {boolean} [enabled] Whether to enable or disable the schedule.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduledRebalancingAPIToggleRebalancingSchedule(organizationId: string, clusterId: string, id: string, enabled?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RebalancingSchedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduledRebalancingAPIToggleRebalancingSchedule(organizationId, clusterId, id, enabled, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledRebalancingAPIApi.scheduledRebalancingAPIToggleRebalancingSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a rebalancing schedule.    (-- api-linter: core::0134::http-body=disabled      aip.dev/not-precedent: Using a custom data field for better SDK generation. --)
         * @summary Updates a rebalancing schedule.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing schedule to update.  This is the RebalancePlanSchedule CRD name (metadata.name).
         * @param {UpdateRebalancingScheduleData} updateRebalancingScheduleData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduledRebalancingAPIUpdateRebalancingSchedule(organizationId: string, clusterId: string, id: string, updateRebalancingScheduleData: UpdateRebalancingScheduleData, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RebalancingSchedule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduledRebalancingAPIUpdateRebalancingSchedule(organizationId, clusterId, id, updateRebalancingScheduleData, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScheduledRebalancingAPIApi.scheduledRebalancingAPIUpdateRebalancingSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScheduledRebalancingAPIApi - factory interface
 * @export
 */
export const ScheduledRebalancingAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScheduledRebalancingAPIApiFp(configuration)
    return {
        /**
         * Creates a new rebalancing schedule  for a cluster.    (-- api-linter: core::0133::http-body=disabled      aip.dev/not-precedent: Using a custom data field for better SDK generation. --)
         * @summary Creates a rebalancing schedule for the cluster.
         * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPICreateRebalancingScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPICreateRebalancingSchedule(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPICreateRebalancingScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RebalancingSchedule> {
            return localVarFp.scheduledRebalancingAPICreateRebalancingSchedule(requestParameters.organizationId, requestParameters.clusterId, requestParameters.createRebalancingScheduleData, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a rebalancing schedule.
         * @summary Deletes a rebalancing schedule.
         * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPIDeleteRebalancingScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPIDeleteRebalancingSchedule(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPIDeleteRebalancingScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RebalancingSchedule> {
            return localVarFp.scheduledRebalancingAPIDeleteRebalancingSchedule(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a rebalancing schedule by ID.
         * @summary Gets a rebalancing schedule.
         * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPIGetRebalancingScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPIGetRebalancingSchedule(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPIGetRebalancingScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RebalancingSchedule> {
            return localVarFp.scheduledRebalancingAPIGetRebalancingSchedule(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists rebalancing schedules for a cluster.
         * @summary Lists rebalancing schedules for a cluster.
         * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPIListRebalancingSchedulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPIListRebalancingSchedules(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPIListRebalancingSchedulesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListRebalancingSchedulesResponse> {
            return localVarFp.scheduledRebalancingAPIListRebalancingSchedules(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.enabledFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * Enables or disables a rebalancing schedule.
         * @summary Enables or disables a rebalancing schedule.
         * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPIToggleRebalancingScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPIToggleRebalancingSchedule(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPIToggleRebalancingScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RebalancingSchedule> {
            return localVarFp.scheduledRebalancingAPIToggleRebalancingSchedule(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.enabled, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a rebalancing schedule.    (-- api-linter: core::0134::http-body=disabled      aip.dev/not-precedent: Using a custom data field for better SDK generation. --)
         * @summary Updates a rebalancing schedule.
         * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPIUpdateRebalancingScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduledRebalancingAPIUpdateRebalancingSchedule(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPIUpdateRebalancingScheduleRequest, options?: RawAxiosRequestConfig): AxiosPromise<RebalancingSchedule> {
            return localVarFp.scheduledRebalancingAPIUpdateRebalancingSchedule(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.updateRebalancingScheduleData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for scheduledRebalancingAPICreateRebalancingSchedule operation in ScheduledRebalancingAPIApi.
 * @export
 * @interface ScheduledRebalancingAPIApiScheduledRebalancingAPICreateRebalancingScheduleRequest
 */
export interface ScheduledRebalancingAPIApiScheduledRebalancingAPICreateRebalancingScheduleRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPICreateRebalancingSchedule
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPICreateRebalancingSchedule
     */
    readonly clusterId: string

    /**
     * 
     * @type {CreateRebalancingScheduleData}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPICreateRebalancingSchedule
     */
    readonly createRebalancingScheduleData: CreateRebalancingScheduleData
}

/**
 * Request parameters for scheduledRebalancingAPIDeleteRebalancingSchedule operation in ScheduledRebalancingAPIApi.
 * @export
 * @interface ScheduledRebalancingAPIApiScheduledRebalancingAPIDeleteRebalancingScheduleRequest
 */
export interface ScheduledRebalancingAPIApiScheduledRebalancingAPIDeleteRebalancingScheduleRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIDeleteRebalancingSchedule
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIDeleteRebalancingSchedule
     */
    readonly clusterId: string

    /**
     * The ID of the rebalancing schedule to delete.  This is the RebalancePlanSchedule CRD name (metadata.name).
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIDeleteRebalancingSchedule
     */
    readonly id: string
}

/**
 * Request parameters for scheduledRebalancingAPIGetRebalancingSchedule operation in ScheduledRebalancingAPIApi.
 * @export
 * @interface ScheduledRebalancingAPIApiScheduledRebalancingAPIGetRebalancingScheduleRequest
 */
export interface ScheduledRebalancingAPIApiScheduledRebalancingAPIGetRebalancingScheduleRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIGetRebalancingSchedule
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIGetRebalancingSchedule
     */
    readonly clusterId: string

    /**
     * The ID of the rebalancing schedule to retrieve.  This is the RebalancePlanSchedule CRD name (metadata.name).
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIGetRebalancingSchedule
     */
    readonly id: string
}

/**
 * Request parameters for scheduledRebalancingAPIListRebalancingSchedules operation in ScheduledRebalancingAPIApi.
 * @export
 * @interface ScheduledRebalancingAPIApiScheduledRebalancingAPIListRebalancingSchedulesRequest
 */
export interface ScheduledRebalancingAPIApiScheduledRebalancingAPIListRebalancingSchedulesRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIListRebalancingSchedules
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIListRebalancingSchedules
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIListRebalancingSchedules
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIListRebalancingSchedules
     */
    readonly pageCursor?: string

    /**
     * Filter by enabled status (optional).
     * @type {boolean}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIListRebalancingSchedules
     */
    readonly enabledFilter?: boolean
}

/**
 * Request parameters for scheduledRebalancingAPIToggleRebalancingSchedule operation in ScheduledRebalancingAPIApi.
 * @export
 * @interface ScheduledRebalancingAPIApiScheduledRebalancingAPIToggleRebalancingScheduleRequest
 */
export interface ScheduledRebalancingAPIApiScheduledRebalancingAPIToggleRebalancingScheduleRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIToggleRebalancingSchedule
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIToggleRebalancingSchedule
     */
    readonly clusterId: string

    /**
     * The ID of the rebalancing schedule to toggle.  This is the RebalancePlanSchedule CRD name (metadata.name).
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIToggleRebalancingSchedule
     */
    readonly id: string

    /**
     * Whether to enable or disable the schedule.
     * @type {boolean}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIToggleRebalancingSchedule
     */
    readonly enabled?: boolean
}

/**
 * Request parameters for scheduledRebalancingAPIUpdateRebalancingSchedule operation in ScheduledRebalancingAPIApi.
 * @export
 * @interface ScheduledRebalancingAPIApiScheduledRebalancingAPIUpdateRebalancingScheduleRequest
 */
export interface ScheduledRebalancingAPIApiScheduledRebalancingAPIUpdateRebalancingScheduleRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIUpdateRebalancingSchedule
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIUpdateRebalancingSchedule
     */
    readonly clusterId: string

    /**
     * The ID of the rebalancing schedule to update.  This is the RebalancePlanSchedule CRD name (metadata.name).
     * @type {string}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIUpdateRebalancingSchedule
     */
    readonly id: string

    /**
     * 
     * @type {UpdateRebalancingScheduleData}
     * @memberof ScheduledRebalancingAPIApiScheduledRebalancingAPIUpdateRebalancingSchedule
     */
    readonly updateRebalancingScheduleData: UpdateRebalancingScheduleData
}

/**
 * ScheduledRebalancingAPIApi - object-oriented interface
 * @export
 * @class ScheduledRebalancingAPIApi
 * @extends {BaseAPI}
 */
export class ScheduledRebalancingAPIApi extends BaseAPI {
    /**
     * Creates a new rebalancing schedule  for a cluster.    (-- api-linter: core::0133::http-body=disabled      aip.dev/not-precedent: Using a custom data field for better SDK generation. --)
     * @summary Creates a rebalancing schedule for the cluster.
     * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPICreateRebalancingScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledRebalancingAPIApi
     */
    public scheduledRebalancingAPICreateRebalancingSchedule(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPICreateRebalancingScheduleRequest, options?: RawAxiosRequestConfig) {
        return ScheduledRebalancingAPIApiFp(this.configuration).scheduledRebalancingAPICreateRebalancingSchedule(requestParameters.organizationId, requestParameters.clusterId, requestParameters.createRebalancingScheduleData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a rebalancing schedule.
     * @summary Deletes a rebalancing schedule.
     * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPIDeleteRebalancingScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledRebalancingAPIApi
     */
    public scheduledRebalancingAPIDeleteRebalancingSchedule(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPIDeleteRebalancingScheduleRequest, options?: RawAxiosRequestConfig) {
        return ScheduledRebalancingAPIApiFp(this.configuration).scheduledRebalancingAPIDeleteRebalancingSchedule(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a rebalancing schedule by ID.
     * @summary Gets a rebalancing schedule.
     * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPIGetRebalancingScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledRebalancingAPIApi
     */
    public scheduledRebalancingAPIGetRebalancingSchedule(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPIGetRebalancingScheduleRequest, options?: RawAxiosRequestConfig) {
        return ScheduledRebalancingAPIApiFp(this.configuration).scheduledRebalancingAPIGetRebalancingSchedule(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists rebalancing schedules for a cluster.
     * @summary Lists rebalancing schedules for a cluster.
     * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPIListRebalancingSchedulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledRebalancingAPIApi
     */
    public scheduledRebalancingAPIListRebalancingSchedules(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPIListRebalancingSchedulesRequest, options?: RawAxiosRequestConfig) {
        return ScheduledRebalancingAPIApiFp(this.configuration).scheduledRebalancingAPIListRebalancingSchedules(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.enabledFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enables or disables a rebalancing schedule.
     * @summary Enables or disables a rebalancing schedule.
     * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPIToggleRebalancingScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledRebalancingAPIApi
     */
    public scheduledRebalancingAPIToggleRebalancingSchedule(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPIToggleRebalancingScheduleRequest, options?: RawAxiosRequestConfig) {
        return ScheduledRebalancingAPIApiFp(this.configuration).scheduledRebalancingAPIToggleRebalancingSchedule(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.enabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a rebalancing schedule.    (-- api-linter: core::0134::http-body=disabled      aip.dev/not-precedent: Using a custom data field for better SDK generation. --)
     * @summary Updates a rebalancing schedule.
     * @param {ScheduledRebalancingAPIApiScheduledRebalancingAPIUpdateRebalancingScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduledRebalancingAPIApi
     */
    public scheduledRebalancingAPIUpdateRebalancingSchedule(requestParameters: ScheduledRebalancingAPIApiScheduledRebalancingAPIUpdateRebalancingScheduleRequest, options?: RawAxiosRequestConfig) {
        return ScheduledRebalancingAPIApiFp(this.configuration).scheduledRebalancingAPIUpdateRebalancingSchedule(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.updateRebalancingScheduleData, options).then((request) => request(this.axios, this.basePath));
    }
}

